export enum LeadExperienceLevel {

    New = "New",
    Experienced = "Experienced",
}
